var map = {
	"./ABISL.jpg": "4372",
	"./HDFC_Life.png": "5827",
	"./HDFC_health.png": "1d2c",
	"./HSL_logo.png": "1b43",
	"./ICICI-Prudential.png": "c4c7",
	"./Protection.svg": "0205",
	"./about_plan.svg": "6c9c",
	"./about_plan_inactive.svg": "f819",
	"./add-more-plan.png": "7b59",
	"./address-details-active.svg": "1747",
	"./address-details.svg": "ab9e",
	"./address-prf-photo-icon.png": "79ee",
	"./age-prf-photo-icon.png": "a5f8",
	"./back-arrow.png": "8970",
	"./back-btn.png": "a4ed",
	"./balance.png": "0d11",
	"./birth-certificate.png": "e027",
	"./blue-badge.png": "0c55",
	"./border-bottom.png": "a542",
	"./boy-profile.png": "9c61",
	"./businessman.png": "d13a",
	"./button.png": "6858",
	"./camera.png": "5e4f",
	"./cancle.png": "f22e",
	"./check-mark.svg": "37e8",
	"./check.png": "722d",
	"./checked.png": "4f4e",
	"./clock.svg": "127c",
	"./cover-yourself.svg": "00ae",
	"./cross.svg": "4915",
	"./currency_rupee.png": "128b",
	"./dashboard-icon.png": "c0c9",
	"./dashboard-icon.svg": "37aa",
	"./death.svg": "4b2d",
	"./delete.png": "b32a",
	"./document.png": "3142",
	"./down-arrow.png": "ab9f",
	"./down_arw.png": "d9ac",
	"./download-arw.png": "4f90",
	"./download.jpg": "99eb",
	"./download.png": "96fc",
	"./downloadPolicy.png": "17fe",
	"./edit-profile.png": "d30b",
	"./email.svg": "7711",
	"./exchange.png": "d5e8",
	"./exide-life.png": "3b5e",
	"./eye.png": "a33f",
	"./family.png": "0f82",
	"./female-inactive.svg": "fb91",
	"./female.png": "d793",
	"./female.svg": "c7a6",
	"./female1.png": "f601",
	"./file.png": "87d4",
	"./filter-icon.png": "2a97",
	"./girl-profile.png": "216b",
	"./hdfc-bank.png": "4fba",
	"./hdfc-bank1.jpg": "a36b",
	"./hdfc-personal.jpg": "894f",
	"./health-details-active.svg": "d782",
	"./health-details.svg": "67a3",
	"./icon1.png": "7d93",
	"./icon2.png": "9aa4",
	"./icon3.png": "e2a7",
	"./icons8-funnel-20.png": "abaa",
	"./icons8-sort-10.png": "407d",
	"./id-card.png": "de6f",
	"./image-after-upload.png": "7fd1",
	"./inactive-male.png": "b661",
	"./indiafirst_logo.webp": "97ec",
	"./info-button.png": "d088",
	"./info.svg": "db39",
	"./kyc-details-active.svg": "f5ac",
	"./kyc-details.svg": "08ce",
	"./landing-page.jpg": "efed",
	"./left-arrow-grey.png": "1e2a",
	"./left-arrow.png": "75fb",
	"./life-cover.svg": "08ea",
	"./link.png": "6ad3",
	"./loader-gray.gif": "5f37",
	"./loading_gif.gif": "730c",
	"./loading_img.png": "4cc2",
	"./logo.png": "9d64",
	"./logo1.png": "b189",
	"./m-balance.png": "f9d9",
	"./m-filter.png": "abc8",
	"./male.png": "fa9b",
	"./male.svg": "c9ba",
	"./maxlife.png": "8bef",
	"./medical.svg": "2bd0",
	"./next-arrow.png": "dfbc",
	"./no-smoking.png": "e3e4",
	"./nominee-details-active.svg": "58f0",
	"./nominee-details.svg": "14a1",
	"./non-smoking-area.png": "4a7a",
	"./non-smoking-inactive.svg": "bf29",
	"./non-smoking.svg": "b79e",
	"./old-tata-aia.png": "b8ae",
	"./orange-badge.png": "e41d",
	"./payment.svg": "c055",
	"./payment_failed.png": "435a",
	"./payment_scuccessful.png": "71c0",
	"./personal-details-active.svg": "ecbb",
	"./personal-details.svg": "4fce",
	"./phone-with-wire.png": "6b16",
	"./phone.svg": "cf63",
	"./photo-icon1.png": "cbee",
	"./plus-icon.png": "4413",
	"./pnb-metlife-logo.jpg": "d376",
	"./policy-dtl1.png": "5909",
	"./policy-dtl2.png": "a575",
	"./policy-dtl3.png": "54d7",
	"./previouse-arrow.png": "bc0e",
	"./primium-pay.svg": "5fcd",
	"./remove-25.png": "f978",
	"./riders.svg": "e624",
	"./riders_inactive.svg": "46e8",
	"./search.svg": "22ee",
	"./smoking-area.png": "9ca0",
	"./smoking-inactive.png": "e7bd",
	"./smoking.png": "a9ec",
	"./smoking.svg": "c471",
	"./sort.png": "8a89",
	"./standing-man.png": "8961",
	"./tata-aia.jpg": "7d50",
	"./tata-aia.png": "d98d",
	"./tax.svg": "eb49",
	"./tick-mark-white.svg": "ad28",
	"./tick-mark.svg": "6a1a",
	"./transgender-inactive.svg": "180e",
	"./transgender.png": "686e",
	"./transgender.svg": "1c52",
	"./upgrade-plan-inactive.svg": "18b5",
	"./upgrade-plan.svg": "1cf6",
	"./upload.png": "894f4",
	"./user-dropdown-arrow.png": "e410",
	"./user-dropdown.png": "ad07",
	"./whatsapp.png": "d253",
	"./yellow-badge.png": "68c6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";